import { defineStore } from 'pinia'
// @ts-ignore
export const useUserStore = defineStore("user", {

    state: () => ({

        LOCALID: null as string | null,
        PARENT_LOCALID: null as string | null,
        ACCNT: null as string | null,
        NAME: null as string | null,
        GRADE: null as number | null,
        STATE: null as number | null,
        TIMEZONE: null as string | null,

        PRODUCT_NAME: null as string | null,
        LIMIT_CONNECT: null as number | null,
        LIMIT_SIZE: null as number | null,
        LIMIT_CONTENT: null as number | null,
        LIMIT_SCREEN: null as number | null,
        LIMIT_PAGE: null as number | null,
        LIMIT_POPUP: null as number | null,
        LIMIT_TTS: null as number | null,
        LIMIT_MONITOR: null as number | null,
        LIMIT_AI_TOKEN: null as number | null,

        FIRETOKEN: null as string | null,

        SEARCH_LOCALID: null as string | null,
        SEARCH_PARENT_LOCALID: null as string | null,
        SEARCH_ACCNT_NAME: null as string | null,

        MENUNAME: null as string | null,

    }),

    
    //값을 읽을 때는 compute사용 - 이건 그냥 멤버변수처럼 호출해서 사용함.
    getters: {
        
        hasSearchID: (state) => state.SEARCH_LOCALID != null && state.SEARCH_LOCALID != undefined,
        hasLocalID: (state) => state.LOCALID != null && state.LOCALID != undefined,
        hasParentID: (state) => state.PARENT_LOCALID != null && state.PARENT_LOCALID != undefined,

        // 로그아웃 등으로 TIMEZONE이 비어도 moment .tz(undefined) 크래시가 나지 않도록 폴백
        timezone: (state) => state.TIMEZONE || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
        limitConnect: (state) => state.LIMIT_CONNECT,
        limitSize: (state) => state.LIMIT_SIZE,
        limitContent: (state) => state.LIMIT_CONTENT,
        limitScreen: (state) => state.LIMIT_SCREEN,
        limitPage: (state) => state.LIMIT_PAGE,
        limitPopup: (state) => state.LIMIT_POPUP,
        limitTts: (state) => state.LIMIT_TTS,
        limitMonitor: (state) => state.LIMIT_MONITOR,
        limitAiToken: (state) => state.LIMIT_AI_TOKEN,

        menuname: (state) => state.MENUNAME,
        name: (state) => state.NAME,
        productName: (state) => state.PRODUCT_NAME,

        grade: (state) => state.GRADE,
        state: (state) => state.STATE,
        localId: (state) => state.LOCALID,
        parentLocalId: (state) => state.PARENT_LOCALID,
        fireToken: (state) => state.FIRETOKEN,
        searchLocalId: (state) => state.SEARCH_LOCALID,
        searchParentLocalId: (state) => state.SEARCH_PARENT_LOCALID,
        searchAccntName: (state) => state.SEARCH_ACCNT_NAME,

    },
    
    actions: {

        setLocalId(value: string) {
            this.LOCALID = value
        },

        setMenuName(value: string) {
            this.MENUNAME = value
        },

        // 여러 필드를 한번에 설정하는 액션
        setUserData(userData: any) {
            if (userData.LOCALID !== undefined) this.LOCALID = userData.LOCALID
            if (userData.PARENT_LOCALID !== undefined) this.PARENT_LOCALID = userData.PARENT_LOCALID
            if (userData.ACCNT !== undefined) this.ACCNT = userData.ACCNT
            if (userData.NAME !== undefined) this.NAME = userData.NAME
            if (userData.GRADE !== undefined) this.GRADE = userData.GRADE
            if (userData.STATE !== undefined) this.STATE = userData.STATE
            if (userData.TIMEZONE !== undefined) this.TIMEZONE = userData.TIMEZONE
            
            if (userData.PRODUCT_NAME !== undefined) this.PRODUCT_NAME = userData.PRODUCT_NAME
            if (userData.LIMIT_CONNECT !== undefined) this.LIMIT_CONNECT = userData.LIMIT_CONNECT
            if (userData.LIMIT_SIZE !== undefined) this.LIMIT_SIZE = userData.LIMIT_SIZE
            if (userData.LIMIT_CONTENT !== undefined) this.LIMIT_CONTENT = userData.LIMIT_CONTENT
            if (userData.LIMIT_SCREEN !== undefined) this.LIMIT_SCREEN = userData.LIMIT_SCREEN
            if (userData.LIMIT_PAGE !== undefined) this.LIMIT_PAGE = userData.LIMIT_PAGE
            if (userData.LIMIT_POPUP !== undefined) this.LIMIT_POPUP = userData.LIMIT_POPUP
            if (userData.LIMIT_TTS !== undefined) this.LIMIT_TTS = userData.LIMIT_TTS
            if (userData.LIMIT_MONITOR !== undefined) this.LIMIT_MONITOR = userData.LIMIT_MONITOR
            if (userData.LIMIT_AI_TOKEN !== undefined) this.LIMIT_AI_TOKEN = userData.LIMIT_AI_TOKEN
            
            if (userData.FIRETOKEN !== undefined) this.FIRETOKEN = userData.FIRETOKEN
            
            if (userData.SEARCH_LOCALID !== undefined) this.SEARCH_LOCALID = userData.SEARCH_LOCALID
            if (userData.SEARCH_PARENT_LOCALID !== undefined) this.SEARCH_PARENT_LOCALID = userData.SEARCH_PARENT_LOCALID
            if (userData.SEARCH_ACCNT_NAME !== undefined) this.SEARCH_ACCNT_NAME = userData.SEARCH_ACCNT_NAME
        },        

        // 로그아웃 - 모든 데이터 초기화
        clearUserData() {
            this.LOCALID = null
            this.PARENT_LOCALID = null
            this.ACCNT = null
            this.NAME = null
            this.GRADE = null
            this.STATE = null
            this.TIMEZONE = null
            
            this.PRODUCT_NAME = null
            this.LIMIT_CONNECT = null
            this.LIMIT_SIZE = null
            this.LIMIT_CONTENT = null
            this.LIMIT_SCREEN = null
            this.LIMIT_PAGE = null
            this.LIMIT_POPUP = null
            this.LIMIT_TTS = null
            this.LIMIT_MONITOR = null
            this.LIMIT_AI_TOKEN = null
            
            this.FIRETOKEN = null
            
            this.SEARCH_LOCALID = null
            this.SEARCH_PARENT_LOCALID = null
            this.SEARCH_ACCNT_NAME = null
        },        

    },

    // sessionStorage를 사용한 지속성 설정
    persist: {
        // sessionStorage 사용
        storage: sessionStorage,

        // 저장할 상태 필드 모두 지정
        paths: [
            'LOCALID',
            'PARENT_LOCALID',
            'ACCNT',
            'NAME',
            'GRADE',
            'STATE',
            'TIMEZONE',
            'PRODUCT_NAME',
            'LIMIT_CONNECT',
            'LIMIT_SIZE',
            'LIMIT_CONTENT',
            'LIMIT_SCREEN',
            'LIMIT_PAGE',
            'LIMIT_POPUP',
            'LIMIT_TTS',
            'LIMIT_MONITOR',
            'LIMIT_AI_TOKEN',
            'FIRETOKEN',
            'SEARCH_LOCALID',
            'SEARCH_PARENT_LOCALID',
            'SEARCH_ACCNT_NAME',
            'MENUNAME'
        ],
    }    

})